export class indCustQuotOtpId{
    custId: string;
    portfolioId: number;
    quotationId: string;
}